import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-sub-board-section-header',
    templateUrl: './sub-board-section-header.component.html',
    styleUrls: ['./sub-board-section-header.component.scss'],
    standalone: false
})
export class SubBoardSectionHeaderComponent implements OnInit {
    @Input() pending: boolean;
    @Input() headerId: string;
    @Input() requestCount: number;
    @Input() urgent = false;

    constructor() {}

    public get countLabelId(): string {
        if (this.pending) {
            return this.requestCount === 1 ? 'SubBoard.PendingCount1' : 'SubBoard.PendingCountMore';
        } else {
            return this.requestCount === 1 ? 'SubBoard.AllCount1' : 'SubBoard.AllCountMore';
        }
    }

    ngOnInit() {}
}
